import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api/client';

/**
 * 결재선 조직 트리 — front `useApproval` 의 같은 이름 훅을 옮겼다.
 *
 * 안전 서버의 조직 사본(`/v1/safe/lookup/org-tree` · DOC-141 §11-3)을 읽는다. 라운지 `/v1/approvals/org-tree` 를
 * 펴 보낸 것이라 모양 · 차례가 같다(계정 있는 재직자만).
 */
export type OrgMember = {
  userId: string;
  name: string;
  rank: string | null;
  rankOrder: number | null;
  position: string | null;
  teamLead: boolean;
};
export type OrgUnit = { unitType: 'DEPARTMENT' | 'SITE'; unitName: string; members: OrgMember[] };

export function useOrgTree() {
  return useQuery({ queryKey: ['approval', 'org-tree'], queryFn: () => apiFetch<OrgUnit[]>('/v1/safe/lookup/org-tree') });
}
